import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../component/layouts/dashboard/dashboard.component';
import { AuthGuard } from '../shared/auth.guard';
import { PermissionGuard } from '../shared/permission.guard';
import { DepartureCheckDashboardComponent } from './departure-check-dashboard/departure-check-dashboard.component';
import { DepartureCheckWizardComponent } from './departure-check-wizard/departure-check-wizard.component';
import { DepartureCheckSummaryComponent } from './departure-check-summary/departure-check-summary.component';

const routes: Routes = [{
    path: "unit/departure-checks", component: DashboardComponent, canActivate: [AuthGuard, PermissionGuard], children: [{
        path: "", component: DepartureCheckDashboardComponent, data: { module: "Unidad", accion: "Unidades por liberar", type: "departure-checks" }
    }, {
        path: "wizard/:id", component: DepartureCheckWizardComponent, data: { module: "Unidad", accion: "Check de salida", type: "departure-check-wizard" }
    }, {
        path: ":id/resumen", component: DepartureCheckSummaryComponent, data: { module: "Unidad", accion: "Resumen del check", type: "departure-check-summary" }
    }]
}];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DepartureCheckRoutingModule { }
